import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import baseURL from "./../../../../Apiurs/Apiurls"
 // change this to your backend

const AddProduct = ({ show, handleClose, handleSave }) => {
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [quantity, setQuantity] = useState(1);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [loadingMainCategories, setLoadingMainCategories] = useState(false);
  const [loadingSubCategories, setLoadingSubCategories] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [error, setError] = useState("");

  // ---------- Fetchers ----------
  const fetchMainCategories = async () => {
    setLoadingMainCategories(true);
    try {
      const res = await axios.get(`${baseURL}/api/main-categories`);
      setMainCategories(res.data);
    } catch {
      setError("Failed to fetch main categories");
    } finally {
      setLoadingMainCategories(false);
    }
  };

  const fetchSubCategories = async (mainCategoryId) => {
    setLoadingSubCategories(true);
    try {
      const res = await axios.get(`${baseURL}/api/sub-categories/${mainCategoryId}`);
      setSubCategories(res.data);
    } catch {
      setError("Failed to fetch sub-categories");
    } finally {
      setLoadingSubCategories(false);
    }
  };

  const fetchProducts = async (subCategoryId) => {
    setLoadingProducts(true);
    try {
      const res = await axios.get(`${baseURL}/api/products/${subCategoryId}`);
      setProducts(res.data);
    } catch {
      setError("Failed to fetch products");
    } finally {
      setLoadingProducts(false);
    }
  };

  // ---------- Effects ----------
  useEffect(() => {
    if (show) fetchMainCategories();
  }, [show]);

  useEffect(() => {
    if (selectedMainCategory) {
      fetchSubCategories(selectedMainCategory);
      setSelectedSubCategory("");
      setProducts([]);
    }
  }, [selectedMainCategory]);

  useEffect(() => {
    if (selectedSubCategory) {
      fetchProducts(selectedSubCategory);
      setSelectedProductId("");
    }
  }, [selectedSubCategory]);

  // ---------- Helpers ----------
  const currency = (num) =>
    new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(num);

  const selectedProduct = useMemo(() => {
    if (!selectedProductId) return null;
    return products.find((p) => String(p.detail_id) === String(selectedProductId)) || null;
  }, [selectedProductId, products]);

const addProduct = () => {
  setError("");
  if (!selectedProduct) {
    setError("Please select a product.");
    return;
  }

  const qtyNum = Math.max(1, parseInt(quantity || 1, 10));

  console.log("👉 Adding product:", {
    ...selectedProduct,
    quantity: qtyNum,
  });

  setSelectedProducts((prev) => {
    const existing = prev.find(
      (x) => String(x.detail_id) === String(selectedProduct.detail_id)
    );

    let updated;
    if (existing) {
      updated = prev.map((item) =>
        String(item.detail_id) === String(selectedProduct.detail_id)
          ? { ...item, quantity: item.quantity + qtyNum } // ✅ increment instead of overwrite
          : item
      );
    } else {
      updated = [
        ...prev,
        {
          ...selectedProduct,
          quantity: qtyNum,
          maincategory_name: mainCategories.find((mc) => String(mc.id) === String(selectedMainCategory))?.maincategory_name || "",
          subcategory_name: subCategories.find((sc) => String(sc.id) === String(selectedSubCategory))?.subcategory_name || "",
        },
      ];
    }

    console.log("✅ Updated product list:", updated);
    return updated;
  });

  setSelectedProductId("");
  setQuantity(1);
};

  const updateProductQty = (id, newQty) => {
    setSelectedProducts((prev) =>
      prev.map((item) =>
        String(item.detail_id) === String(id)
          ? { ...item, quantity: Math.max(1, parseInt(newQty || 1, 10)) }
          : item
      )
    );
  };

  const removeProduct = (id) => {
    setSelectedProducts((prev) => prev.filter((item) => String(item.detail_id) !== String(id)));
  };

  const onSave = () => {
    handleSave(selectedProducts);
    setSelectedProducts([]);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Products</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Product Selection */}
        <div className="card shadow-sm mb-3">
          <div className="card-body">
            <h5 className="mb-3">Select Products</h5>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label">Main Category</label>
                <select
                  className="form-select"
                  value={selectedMainCategory}
                  onChange={(e) => setSelectedMainCategory(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {mainCategories.map((mc) => (
                    <option key={mc.id} value={mc.id}>
                      {mc.maincategory_name}
                    </option>
                  ))}
                </select>
                {loadingMainCategories && <small className="text-muted">Loading…</small>}
              </div>
              <div className="col-md-4">
                <label className="form-label">Sub Category</label>
                <select
                  className="form-select"
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                  disabled={!selectedMainCategory}
                >
                  <option value="">-- Select --</option>
                  {subCategories.map((sc) => (
                    <option key={sc.id} value={sc.id}>
                      {sc.subcategory_name}
                    </option>
                  ))}
                </select>
                {loadingSubCategories && <small className="text-muted">Loading…</small>}
              </div>
              <div className="col-md-5">
                <label className="form-label">Product (Name • Batch • Size • Price)</label>
                <select
                  className="form-select"
                  value={selectedProductId}
                  onChange={(e) => setSelectedProductId(e.target.value)}
                  disabled={!selectedSubCategory || !products.length}
                >
                  <option value="">-- Select --</option>
                  {products.map((p) => (
                    <option key={p.detail_id} value={p.detail_id}>
                      {p.product_name} • {p.batch} • {p.size || "-"} • {currency(p.listprice)}
                    </option>
                  ))}
                </select>
                {loadingProducts && <small className="text-muted">Loading…</small>}
              </div>
              <div className="col-md-2">
                <label className="form-label">Quantity</label>
                <input
                  type="number"
                  className="form-control"
                  min={1}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  disabled={!selectedProductId}
                />
              </div>
              <div className="col-md-2 d-grid">
                <button
                  className="btn btn-primary"
                  onClick={addProduct}
                  disabled={!selectedProductId}
                >
                  Add to List
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Selected Products Table */}
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="m-0">Selected Products</h5>
              <small className="text-muted">{selectedProducts.length} item(s)</small>
            </div>
            <div className="table-responsive">
              <table className="table table-sm table-bordered align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ minWidth: 220 }}>Product</th>
                    <th>Model</th>
                    <th>Size</th>
                    <th className="text-end">Price</th>
                    <th style={{ width: 120 }}>Qty</th>
                    <th className="text-end">GST %</th>
                    <th className="text-end">Line Total</th>
                    <th style={{ width: 60 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {selectedProducts.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center text-muted py-4">
                        No products added yet.
                      </td>
                    </tr>
                  ) : (
                    selectedProducts.map((item) => {
                      const price = Number(item.listprice || 0);
                      const qty = Number(item.quantity || 0);
                      const line = price * qty;
                      const gstPct = Number(item.gstrate || 0);
                      return (
                        <tr key={item.detail_id}>
                          <td>
                            <div className="fw-semibold">{item.product_name}</div>
                            {item.description && (
                              <small className="text-muted">{item.description}</small>
                            )}
                          </td>
                          <td>{item.batch}</td>
                          <td>{item.size || "-"}</td>
                          <td className="text-end">{currency(price)}</td>
                          <td>
                            <input
                              type="number"
                              min={1}
                              className="form-control form-control-sm"
                              value={qty}
                              onChange={(e) =>
                                updateProductQty(item.detail_id, e.target.value)
                              }
                            />
                          </td>
                          <td className="text-end">{gstPct}%</td>
                          <td className="text-end">{currency(line)}</td>
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => removeProduct(item.detail_id)}
                            >
                              ✕
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={onSave} disabled={!selectedProducts.length}>
          Save Products
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddProduct;
